import { ReactNode, useContext } from 'react';
import themeContext from '../../../context/theme/themeContext';
import Cover from '../../../layout/Cover';
import AverageApy from './Spool/AverageApy';
import ClaimableIncentivizedEarnings from './Spool/ClaimableIncentivizedEarnings';
import PendingWithdrawals from './Spool/PendingWithdrawals';
import TotalBalance from './Spool/TotalBalance';
import TotalYieldToDate from './Spool/TotalYieldToDate';
import ReadyToWithdraw from './Spool/ReadyToWithdraw';
import PendingDeposits from './Spool/PendingDeposits';
import StakedSpool from './Staking/StakedSpool';
import AcccumulatedVoSpool from './Staking/AccumulatedVoSpool';
import ClaimableStakingEmissions from './Staking/ClaimableStakingEmissions';
import StakingEmissionsToDate from './Staking/StakingEmissionsToDate';
// import ClaimableFees from './FeesEarned/ClaimableFees';
// import FeesEarnedToDate from './FeesEarned/FeesEarnedToDate';

const PlatformSummary: React.FC<ReactNode> = () => {
    const { theme } = useContext(themeContext);

    return (
        <div className={`vault-tab summary ${theme}`}>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Spool</h2>
                </div>
                <div className='inner__right'>
                    <TotalBalance />
                    <TotalYieldToDate />
                    <AverageApy />
                    <ClaimableIncentivizedEarnings />
                    <PendingWithdrawals />
                    <ReadyToWithdraw />
                    <PendingDeposits />
                </div>
                <div className='inner__left'>
                    <h2>Staking</h2>
                </div>
                <div className='inner__right'>
                    <StakedSpool />
                    <AcccumulatedVoSpool />
                    <ClaimableStakingEmissions />
                    <StakingEmissionsToDate />
                </div>
            </Cover>
        </div>
    );
};

export default PlatformSummary;
